import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { AppService } from '../app/app.service';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs/Observable';
import * as UtilityLib from '@flysas/utility-lib/lib/Utility.min'

@Injectable()
export class UtilService {

  public utility: any;
  private oauthApiObservable = new Subject<boolean>();
  constructor(private appService: AppService) { }

  initiateUtilLib(currentPos) {
    this.utility = new UtilityLib.Utility({
      lang: this.appService.appLanguage,
      market: currentPos,
      isOauthRequired: false,
      apiBaseUrl: environment.apiBaseUrl,
      oauthSuccessCallBack: () => this.oauthSuccess()
    });
  }

  oauthSuccess() {
    this.setOauthSuccess();
  }

  setOauthSuccess() {
    this.oauthApiObservable.next();
  }

  getOauthSuccess(): Observable<boolean> {
    return this.oauthApiObservable.asObservable();
  }

  newEBUserLogout() {
    sessionStorage.removeItem('sessionId');
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('isAuthenticated');
    localStorage.removeItem('ebLogin');
  }

}
